module.exports = __webpack_public_path__ + "img/whats_app.1813cf88.svg";